import { ListContent } from '#graphql';

export const getDefaultGroupValues = (values: ListContent[], name: string) =>
  Number(values.find((value) => value.name === name)?.description) || 0;
